'use client'
import {usePathname, useSearchParams} from 'next/navigation'
import {useOptimistic, useTransition} from 'react'

export const useOptimisticChecked = () => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const checked = searchParams.get('pricing') !== 'monthly'
  const [optimisticChecked, setOptimisticChecked] = useOptimistic(checked)
  const [pending, startTransition] = useTransition()

  function handleCheckedChange(checked: boolean) {
    const params = new URLSearchParams(searchParams.toString())
    params.set('pricing', checked ? 'annual' : 'monthly')
    startTransition(() => {
      setOptimisticChecked(checked)
      // TODO: CP-1095 - why doesn't this work w/ next/navigation?
      window.history.replaceState(null, '', `${pathname}?${params.toString()}`)
    })
  }
  return {
    optimisticChecked,
    pending,
    handleCheckedChange,
  }
}
